import { Container, Grid } from "@mui/material";
import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import "./index.css";
import FooterBasic from "./components/Footer";
import Navigation from "./components/NavBar";
import Main from "./components/Main";
import Agents from "./components/Agents";
import AgentInfo from "./components/AgentInfo";
import Services from "./components/Services";
import ContactForm from "./components/Contacts";
import NewOrder from "./components/Order";
import QuestionnaireComponent from "./components//QuestionnaireComponent";
import TermsAndConditions from "./components/TermsAndConditions";

import CartPage from "./components/CardPage";

function App() {


  return (
    <div className="App">
      <Navigation />
      <Container>
        <Grid
          container
          display="flex"
          alignItems="center"
          mt="20px"
          fullwidth="true"
        >
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/contacts" element={<ContactForm />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/agentInfo/:abb" element={<AgentInfo />} />
            <Route path="/services" element={<Services />} />
            <Route path="/order" element={<NewOrder />} />
            <Route path="/inquiry" element={<QuestionnaireComponent />} />
            <Route path="/terms" element={<TermsAndConditions />} />

            <Route path="/cart" element={<CartPage />} />
          </Routes>
        </Grid>
      </Container>
      {/* <div className="App">
      <form onSubmit={submithandler}>
        <input type= "text" ref={dataRef} />
        <button type = "submit">Save</button>
      </form>
    </div> */}
      <FooterBasic />
    </div>
  );
}

export default App;
